/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';
import { AppBanner as AppBannerComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/AppBanner.css';
import '@spotahome/ui-library/lib/components/Rating.css';

import { MQ_MOBILE_MAX_WIDTH } from '../constants';

import './AppBanner.scss';

const buildDeeplink = (slug = '') => {
  const sessionId =
    typeof window !== 'undefined' && window.__CONTEXT__
      ? window.__CONTEXT__.__EXPERIMENTS_SESSION_ID__
      : '';
  return `https://spotahome.app.link/${slug}${sessionId &&
    `?webSessionId=${sessionId}`}`;
};

const PROPS_BY_SOURCE = {
  search: {
    eventAction: 'banner-click-searchpage',
    openPath: buildDeeplink('banner_search')
  },
  listing: {
    eventAction: 'banner-click-productpage',
    openPath: buildDeeplink('banner_listing')
  },
  chat: {
    eventAction: 'banner-click-chatpage',
    openPath: buildDeeplink('banner_chat')
  }
};

const AppBanner = ({ source }) => (
  <NoSSR>
    <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
      <div className="app-banner-wrapper">
        <AppBannerComponent
          title={trans('appbanner.title')}
          className="app-banner"
          {...PROPS_BY_SOURCE[source]}
        />
      </div>
    </MediaQuery>
  </NoSSR>
);
AppBanner.propTypes = {
  source: PropTypes.oneOf(Object.keys(PROPS_BY_SOURCE)).isRequired
};
export default AppBanner;
